// returns an integer.
// returns the integer value of the smallest viewport dimension.
// So in portrait mode it returns the width of the viewport.
// …in landscape it returns the height of the viewport.

export default function () {
  var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
  var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)

  return w > h ? h : w
}
